// extracted by mini-css-extract-plugin
export default {"dragIcon":"styles__dragIcon___IFV5X"};